// extracted by mini-css-extract-plugin
export default {"todoItem":"Todos_todoItem__LMNh+","todoText":"Todos_todoText__J4jgZ","actionContainer":"Todos_actionContainer__tnhwj","action":"Todos_action__G3KDa","editBtn":"Todos_editBtn__FzZOW"};